/** Dieselbe Form, die der Server annimmt (``articles/schemas.py``, ``Address``). */
const ADDRESS = /^[^@\s,;<>]+@[^@\s,;<>]+\.[^@\s,;<>]+$/;

export function isAddress(text: string): boolean {
  return ADDRESS.test(text.trim());
}
